export type DependencyType = 'require' | 'jQuery';

export const DEPENDENCIES: DependencyType[] = ['require', 'jQuery'];

export const POLLING_TIMEOUT_MS = 60 * 1000;
